import { getClasses } from '@/_utils/classnames';
import { Heading, Separator, Flex, Icon, Pill } from '@/_components';
import {
  getFlexUtility,
  getSafeFlexProps,
} from '@/_components/Flex/Flex.utils';
import styles from './Card.module.css';
import type { CardProps } from './Card.types';
import type { FC } from 'react';

export const Card: FC<CardProps> = (props) => {
  const { 'data-testid': dataTestId } = props;
  const flexClasses: string = getFlexUtility(props);
  const cardClasses: string = getClasses(
    styles.card,
    styles.cardBorder,
    flexClasses,
    {
      [styles.cardBase]: props.elevation === 'base',
      [styles.cardMd]: props.elevation === 'md',
      [styles.cardLg]: props.elevation === 'lg',
      [styles.cardXl]: props.elevation === 'xl',
    },
  );

  const safeProps = getSafeFlexProps(props);

  return (
    <Flex
      {...safeProps}
      className={cardClasses}
      isColumn={!props.isRow}
      data-testid={dataTestId}
    >
      {props.header && (
        <>
          <Flex padding={10} className={styles.cardHeader} isBetween={true}>
            <Flex isYCentered={true} gap={6}>
              {props.headerIcon && (
                <Icon
                  size={24}
                  name={props.headerIcon}
                  className={styles.card__headerIcon}
                />
              )}
              <Heading
                level={4}
                data-testid={
                  props.header === 'Sign In' ? 'Card-sign-in-header' : undefined
                }
              >
                {props.header}
              </Heading>
              {props.headerLabel && (
                <Pill
                  isRound={true}
                  size="normal"
                  intent="accent"
                  label={props.headerLabel}
                />
              )}
              {props.headerLeft}
            </Flex>
            {props.headerButtons}
          </Flex>
          <Separator />
        </>
      )}
      {props.children}
    </Flex>
  );
};
